<template>
    <div>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCol sm="12" @click="GoToSetting()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left"/>
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                        <div :class="{'grey-background': activeButton === button.value, 'font-color-98A2B3': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                            {{ button.label }}
                        </div>
                    </CCol>
    
                </CRow>
            </CCard>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div v-if="activeButton === 'detail'">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-500 font-color-171717">Subscription Details</h3>
                            </CCol>
                            <CCol sm="2">
                                <div class="text-right">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white custom-button-padding" @click="openAddCompany()">
                                        <img src="../assets/img/downgrade.png" width="20px" /> Downgrade</CButton>
                                </div>
                            </CCol>
                        </CRow>
    
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-AEAEB2">Company Name</h3>
                                <label class="custom-16px-500 font-color-171717">{{ user.name }}</label>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-AEAEB2">Subcription Date</h3>
                                <label class="custom-16px-500 font-color-171717">{{ user.name }}</label>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-AEAEB2">Subscription Type</h3>
                                <label class="custom-16px-500 font-color-171717"></label>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-AEAEB2">Total Payment</h3>
                                <label class="custom-16px-500 font-color-171717">RM200</label>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-AEAEB2">Total Staff</h3>
                                <label class="custom-16px-500 font-color-171717">30</label>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-AEAEB2">Remarks<strong class="text-danger">*</strong></h3>
                                <label class="custom-16px-500 font-color-171717">Auto Clock Out</label>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-AEAEB2">Payment Term</h3>
                                <label class="custom-16px-500 font-color-171717">N/A</label>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
                            <CCol sm="12">
                                <CAlert show color="danger"><strong class="text-danger">Notes:</strong></CAlert>
                            </CCol>
    
                        </CRow>
    
    
                    </div>
                </div>
    
                <div v-if="activeButton === 'invoice'">
                    <div class="p-2">
                        <h3 class="custom-18px-500 font-color-171717">Subscription Invoice</h3>
                        <hr class="custom-hr" />
                        <div>
    
                            <v-client-table :data="paymentData" :columns="columnsPayment" :options="options" class="custom-table" v-if="paymentData.length > 0">
                                <template v-slot:No="{ row }">
            <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Invoice="{ row }">
    <label class="custom-12px-500">{{ row.Invoice }}</label>
</template>

<template v-slot:Subscription Date="{ row }">
    <label class="custom-12px-500">{{ 'row.Subscription Date' }}</label>
</template>

<template v-slot:Amount="{ row }">
    <label class="custom-12px-500">{{ row.Amount }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500 bg-F2F4F7 font-color-0B63F6">{{ row.Status }}</label>
</template>


<template v-slot:Action="{ row }">
    <div class="d-flex">
        <img :src="require('@/assets/img/printer.png')" alt="Print" style="cursor: pointer;width:30px" @click="printRow(row.Index)" />
        <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
    </div>
</template>
              </v-client-table>
              <div v-else class="no-data-message text-center" style="margin:10%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
    </div>

    </div>
                       
    
                    </div>
                </div>
    
    
            </CCard>
        </CCol>
    
        <div v-if="OpenAddCompany" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Edit</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddCompany" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <div class="text-center p-1">
                                    <CCard>
                                        <div class="text-center">
                                            <br /><br />
                                            <img :src="company.LogoPath" style="max-width:150px" v-if="filePreview == null" />
    
                                            <img :src="filePreview" style="max-width: 100px; cursor: pointer;" @click="triggerFileInput" />
                                            <input type="file" ref="fileInput" @change="onFileChange" style="display: none;" />
                                            <p class="font-color-0B63F6" @click="triggerFileInput">Click to upload</p>
                                            <p class="font-color-98A2B3">SVG, PNG, JPG, or GIF (max. 800x400px)</p>
    
                                            <!-- Display the file name if an image is not uploaded -->
                                            <p v-if="fileName" class="mt-2 mb-5">{{ fileName }}</p>
                                        </div>
    
    
                                    </CCard>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="8">
                                        <h3 class="custom-14px-500 font-color-171717">Company Name</h3>
                                        <CInput type="text" v-model="company.FullName" />
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Company Short Name</h3>
                                        <CInput type="text" v-model="company.ShortName" />
                                    </CCol>
                                    <CCol sm="5">
                                        <h3 class="custom-14px-500 font-color-171717">Company Registration Number</h3>
                                        <CInput type="text" v-model="company.RegistrationNumber" />
                                    </CCol>
                                    <CCol sm="3">
                                        <h3 class="custom-14px-500 font-color-171717">Company Type</h3>
                                        <v-select v-model="SelectedType" :options="companyType" label="Name"></v-select>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Industry</h3>
                                        <v-select v-model="SelectedIndustryType" :options="industryOptions" label="Name"></v-select>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Email</h3>
                                <CInput type="text" v-model="company.Email" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Phone Number</h3>
                                <CInput type="text" v-model="company.PhoneNumber" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Fax</h3>
                                <CInput type="text" v-model="company.Fax" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Street Address</h3>
                                <CInput type="text" v-model="company.Address" />
                            </CCol>
    
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Country</h3>
                                <v-select v-model="SelectedCountry" :options="countryOptions" label="CountryName" @input="GetListState(SelectedCountry.Id)"></v-select>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">State</h3>
                                <v-select v-model="SelectedState" :options="stateOptions" label="Name" @input="GetListCity(SelectedState.Id)"></v-select>
                            </CCol>
                            <CCol sm="6" class="mt-2">
                                <h3 class="custom-14px-500 font-color-171717">City</h3>
                                <v-select v-model="SelectedCity" :options="cityOptions" label="Name"></v-select>
                            </CCol>
    
                            <CCol sm="6" class="mt-3">
                                <h3 class="custom-14px-500 font-color-171717">Postal Code</h3>
                                <CInput type="text" v-model="company.Postcode" />
                            </CCol>
    
    
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Save Changes</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
    
      
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
        
    
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            activeButton: 'detail', // Default active button
            buttons: [
                { value: 'detail', label: 'Subsciption Details', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'invoice', label: 'Subcription Invoice', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],

            options: {
                perPage: 5,
                pagination: true,
                filterable: false,
            },
            user: {},

            columnsPayment: [
                'No',
                'Invoice',
                'Subscription Date',
                'Amount',
                'Status',
            ],
            paymentData: [
                { No: 1, Invoice: '1234567890', 'Subscription Date': '14 May 2024 - 14 May 2025', 'Amount': 'RM 669.60', 'Status': 'Active'},
                { No: 2, Invoice: '1234567891', 'Subscription Date': '14 May 2022 - 14 May 2023', 'Amount': 'RM 669.60', 'Status': 'Active'},
                { No: 3, Invoice: '1234567892', 'Subscription Date': '14 May 2020 - 14 May 2022', 'Amount': 'RM 669.60', 'Status': 'Active'}
            ],







        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();

            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        GoToSetting()
        {
            this.$router.push("Setting");
        }




    }

};
</script>